import React from 'react';
import { useTranslation } from 'react-i18next';

import { AssetManager } from '../../../../../viewer/asset-manager';
import { InputHandler } from '../../../../../viewer/input-handler';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { useFeatureFlag } from '../../../../hooks/use-feature-flag';
import { useNonce } from '../../../../hooks/use-nonce';
import { useSubscribe } from '../../../../hooks/use-subscribe';
import { ToolIcon } from '../tool-icon';

const MeasurementAdvancedToolIcon = () => {
  const { t } = useTranslation();
  const [_, refresh] = useNonce();
  // The snapping dialog replaces it.
  const snappingOptions = useFeatureFlag('SK-7558-measure-snapping-options');

  useSubscribe(SubscriptionTopic.SetTool, refresh);
  useSubscribe(SubscriptionTopic.NewSelection, refresh);
  useSubscribe(SubscriptionTopic.UnSelection, refresh);

  const onClick = () => {
    InputHandler.instance.toggleAssetMeasuring(!InputHandler.instance.getAssetMeasuringState());
    refresh();
  };

  if (snappingOptions) {
    return null;
  }

  const isActive = InputHandler.instance.getAssetMeasuringState();
  const isEnabled =
    InputHandler.instance.isMeasureToolActive() ||
    (InputHandler.instance.isSelectToolActive() &&
      AssetManager.instance.getSelected()?.objType === 'Geometry');

  return (
    <ToolIcon
      active={isActive}
      callback={onClick}
      disabled={!isEnabled}
      icon={['fal', 'magnet']}
      tooltip={{
        title: t('measurementAdvanced.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('measurementAdvanced.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { MeasurementAdvancedToolIcon };
